<template>
  <g>
    <circle :cx="cx" :cy="cy" :r="r" />
    <svg-badge :x="lx" :y="ly" variant="primary" :scale="scale">${{ annotation.label }}</svg-badge>
  </g>
</template>

<script>
  import { AnnotationResource } from '@/api-resources';
  import SvgBadge from './SvgBadge';

  export default {
    name: 'AnnotationCircle',

    components: {
      SvgBadge,
    },

    props: {
      annotation: AnnotationResource,
      scale: Number,
    },

    computed: {
      cx() {
        return this.annotation.coordinates[0] + this.annotation.originRow;
      },

      cy() {
        return this.annotation.coordinates[1] + this.annotation.originColumn;
      },

      r() {
        const a = Math.pow(this.annotation.coordinates[2] - this.annotation.coordinates[0], 2);
        const b = Math.pow(this.annotation.coordinates[3] - this.annotation.coordinates[1], 2);

        return Math.sqrt(a + b);
      },

      lx() {
        return this.cx;
      },

      ly() {
        return this.cy + this.r + 10;
      },
    },
  };
</script>
